// Mock data for SEBINOR COMPUTACION landing page

export const heroData = {
  title: "SEBINOR",
  subtitle: "COMPUTACION",
  tagline: "Tu experto en tecnología desde el diagnóstico hasta la solución",
  services: ["Servicio Técnico", "Armado de PC", "Consolas", "VR MetaQuest", "Software"]
};

export const servicesData = [
  {
    id: 1,
    title: "Servicio Técnico",
    description: "Reparación profesional de computadoras, notebooks, consolas y dispositivos electrónicos con diagnóstico gratuito.",
    category: "service"
  },
  {
    id: 2,
    title: "Armado de PC",
    description: "Diseñamos tu PC gaming o de trabajo a medida, con los mejores componentes y garantía extendida.",
    category: "build"
  },
  {
    id: 3,
    title: "Venta de Insumos",
    description: "Componentes, periféricos y accesorios de las mejores marcas del mercado.",
    category: "sales"
  },
  {
    id: 4,
    title: "Realidad Virtual",
    description: "Distribuidores oficiales MetaQuest. Experimenta el futuro de la tecnología inmersiva.",
    category: "vr"
  }
];

export const outletProducts = [
  {
    id: 1,
    name: "Notebook MSI 15.4\" - Ofertón del Mundial",
    originalPrice: 204000,
    discountPrice: 103199,
    category: "Notebook",
    condition: "Reacondicionada",
    warranty: "3 meses",
    description: "MSI 2 núcleo 2.8GHz, 4GB RAM DDR3, SSD 240GB, WiFi, Pantalla 15.4\", Windows 10 + Office",
    image: "https://customer-assets.emergentagent.com/job_vr-techsolutions/artifacts/odwifr1y_New%20Arrival%20Laptop%20Ads%20-%20Hecho%20con%20PosterMyWall.jpg"
  },
  {
    id: 2,
    name: "Notebook Lenovo - Promo Outlet",
    originalPrice: 384000,
    discountPrice: 192000,
    category: "Notebook",
    condition: "Reacondicionada",
    warranty: "3 meses",
    description: "Intel Doble Núcleo, 4GB RAM DDR3, Disco 320GB, Todas las tarjetas",
    image: "https://customer-assets.emergentagent.com/job_vr-techsolutions/artifacts/kxtab336_Laptop%20Promo%20A4%20-%20Hecho%20con%20PosterMyWall.jpg"
  },
  {
    id: 3,
    name: "Notebook Xiaomi - Outlet Premium",
    originalPrice: 456000,
    discountPrice: 227999,
    category: "Notebook",
    condition: "Reacondicionada",
    warranty: "3 meses",
    description: "Intel 1.8GHz, 4GB RAM, SSD 160GB, WiFi, Cámara, Windows 10, Cargador Original",
    image: "https://customer-assets.emergentagent.com/job_vr-techsolutions/artifacts/8b25qvg6_Laptop%20Sale%20-%20Hecho%20con%20PosterMyWall.jpg"
  },
  {
    id: 4,
    name: "PC Escritorio - Regreso a Clases",
    originalPrice: 372000,
    discountPrice: 336000,
    category: "PC Escritorio",
    condition: "Nueva",
    warranty: "6 meses",
    description: "Windows 10, Office 2016, Antivirus, Acceso a IA, 4GB RAM, Disco SSD - 10% Descuento hasta agotar stock",
    image: "https://customer-assets.emergentagent.com/job_vr-techsolutions/artifacts/i916l8se_White%20Professional%20Computer%20Repair%20Services%20A2%20-%20Hecho%20con%20PosterMyWall%20%281%29.jpg"
  },
  {
    id: 5,
    name: "PC Escritorio - Lista para Usar",
    originalPrice: 420000,
    discountPrice: 348000,
    category: "PC Escritorio",
    condition: "Nueva",
    warranty: "6 meses",
    description: "AMD A4 3300, 4GB RAM, Placa de Video 2GB, Sonido 5.1, Windows 10, Disco Rígido 1TB",
    image: "https://customer-assets.emergentagent.com/job_vr-techsolutions/artifacts/k2thpp8h_computer%20repair%20services%20template%20-%20Hecho%20con%20PosterMyWall.jpg"
  },
  {
    id: 6,
    name: "PC Escritorio - Promo Especial",
    originalPrice: 384000,
    discountPrice: 336000,
    category: "PC Escritorio",
    condition: "Nueva",
    warranty: "6 meses",
    description: "Windows 10, Office 2016, Antivirus, 4GB RAM, SSD - Ideal para estudio y trabajo",
    image: "https://customer-assets.emergentagent.com/job_vr-techsolutions/artifacts/86m0fwg9_White%20Professional%20Computer%20Repair%20Services%20A2%20-%20Hecho%20con%20PosterMyWall.jpg"
  },
  {
    id: 7,
    name: "Outlet de Consolas - 3 Meses Garantía",
    originalPrice: 420000,
    discountPrice: 336000,
    category: "Consolas",
    condition: "Reacondicionada",
    warranty: "3 meses",
    description: "PS4, PS5, Xbox, Nintendo Switch - Compra con confianza. Calidad y Ahorro Asegurados",
    image: "https://customer-assets.emergentagent.com/job_vr-techsolutions/artifacts/e3ji3565_Gemini_Generated_Image_3hgc1t3hgc1t3hgc.png"
  },
  {
    id: 8,
    name: "Outlet de Televisores - 3 Meses Garantía",
    originalPrice: 480000,
    discountPrice: 384000,
    category: "TV",
    condition: "Reacondicionado",
    warranty: "3 meses",
    description: "Smart TV LED - Compra con confianza. Calidad y Ahorro Asegurados",
    image: "https://customer-assets.emergentagent.com/job_vr-techsolutions/artifacts/ieabwt39_oferta%20de%20tvs.jpg"
  },
  {
    id: 9,
    name: "Monitor 22\" - Oferta Única",
    originalPrice: 144000,
    discountPrice: 102000,
    category: "Monitor",
    condition: "Excelente Estado",
    warranty: "3 meses",
    description: "Monitor 22 pulgadas, Sonido, VGA y DVI, Cable Power - Garantía de 3 meses",
    image: "https://customer-assets.emergentagent.com/job_vr-techsolutions/artifacts/3tghb5kv_A%20New%20Design%20-%20Hecho%20con%20PosterMyWall%20%283%29.jpg"
  },
  {
    id: 10,
    name: "Monitor Samsung LCD 19\"",
    originalPrice: 240000,
    discountPrice: 192000,
    category: "Monitor",
    condition: "Excelente Estado",
    warranty: "3 meses",
    description: "Monitor Samsung LCD 19 pulgadas, excelente estado, ideal para oficina o estudio",
    image: "https://customer-assets.emergentagent.com/job_tech-repair-site-1/artifacts/ao3g9l5q_monitor%20samsung.jpg"
  },
  {
    id: 11,
    name: "PlayStation 3 Slim - HEN Activado",
    originalPrice: 540000,
    discountPrice: 432000,
    category: "Consolas",
    condition: "Excelente Estado",
    warranty: "3 meses",
    description: "PS3 Slim con HEN activado, incluye joystick original, +50 juegos digitales y cable de carga. Lista para jugar!",
    image: "https://customer-assets.emergentagent.com/job_tech-repair-site-1/artifacts/rn6aqz1d_ps3%20folleto.jpg"
  },
  {
    id: 12,
    name: "Xbox 360 Slim - Super Oferta",
    originalPrice: 420000,
    discountPrice: 336000,
    category: "Consolas",
    condition: "Excelente Estado",
    warranty: "3 meses",
    description: "Xbox 360 Slim con disco de 250GB, incluye FIFA y cables. Ideal para gaming!",
    image: "https://customer-assets.emergentagent.com/job_tech-repair-site-1/artifacts/pbgslbzs_oferta%20xbox.jpg"
  }
];

export const newEquipment = [
  {
    id: 1,
    name: "PC Gamer AMD Ryzen 3 3200G",
    price: 624000,
    category: "PC Nuevas",
    brand: "SEBINOR Custom",
    stock: 5,
    featured: true,
    description: "AMD Ryzen 3 3200G, 8GB RAM, Disco SSD 240GB, Gabinete Kit completo",
    image: "https://customer-assets.emergentagent.com/job_vr-techsolutions/artifacts/ouyna06b_kit%201.png"
  },
  {
    id: 2,
    name: "PC Gamer AMD Ryzen 5 5600G",
    price: 972000,
    category: "PC Nuevas",
    brand: "SEBINOR Custom",
    stock: 3,
    featured: true,
    description: "AMD Ryzen 5 5600G, 8GB RAM, SSD 240GB, Gabinete RGB",
    image: "https://customer-assets.emergentagent.com/job_vr-techsolutions/artifacts/9s88dbag_kit%202.jpg"
  },
  {
    id: 3,
    name: "PC Gamer AMD Ryzen 5 3400G",
    price: 900000,
    category: "PC Nuevas",
    brand: "SEBINOR Custom",
    stock: 4,
    featured: true,
    description: "AMD Ryzen 5 3400G, 16GB RAM, SSD 1TB, Gabinete Kit completo",
    image: "https://customer-assets.emergentagent.com/job_vr-techsolutions/artifacts/1296c3m6_kit%201.png"
  },
  {
    id: 4,
    name: "Notebook ASUS Vivobook X1404",
    price: 1078800,
    category: "Notebooks",
    brand: "ASUS",
    stock: 3,
    featured: true,
    description: "Intel Core i5, 8GB RAM, SSD 256GB, Color Azul",
    image: "https://customer-assets.emergentagent.com/job_vr-techsolutions/artifacts/84wd0c05_asus%201.jpg"
  },
  {
    id: 5,
    name: "Notebook Dell Inspiron 3535",
    price: 1500000,
    category: "Notebooks",
    brand: "Dell",
    stock: 2,
    featured: true,
    description: "Ryzen 7 7730U, 16GB RAM, SSD 1TB, Pantalla 15.6\" Touch",
    image: "https://customer-assets.emergentagent.com/job_vr-techsolutions/artifacts/y5z5u966_dell%20notebook.jpg"
  }
];

export const technicianServices = [
  {
    id: 1,
    name: "Diagnóstico General",
    price: 18000,
    duration: "30-60 min",
    description: "Evaluación completa del equipo"
  },
  {
    id: 2,
    name: "Visita Técnica a Domicilio",
    price: 18000,
    duration: "A coordinar",
    description: "Incluye diagnóstico inicial en tu ubicación"
  },
  {
    id: 3,
    name: "Servicio Técnico de TV - Retiro y Entrega",
    price: 24000,
    duration: "A coordinar",
    description: "Retiro y entrega de equipo en localidad de San Miguel y Moreno"
  }
];

export const contactInfo = {
  phone: "+54 9 15 2610-6011",
  email: "sebinorcomputacion@yahoo.com",
  address: "Av. Libertador 7615",
  hours: {
    weekdays: "Martes a Sábado: 9:30 - 16:30 (corrido)",
    saturday: "",
    sunday: "Domingos: 9:30 - 13:00"
  },
  social: {
    instagram: "@sebinor_computacion",
    facebook: "SEBINOR Computación",
    whatsapp: "5491526106011",
    tiktok: "https://www.tiktok.com/@sebinor_computacion2023"
  }
};

export const testimonials = [
  {
    id: 1,
    name: "Martín G.",
    text: "Excelente servicio. Me armaron la PC de mis sueños a un precio justo.",
    rating: 5
  },
  {
    id: 2,
    name: "Laura P.",
    text: "El técnico vino a casa y resolvió todo en una hora. Super profesionales.",
    rating: 5
  },
  {
    id: 3,
    name: "Diego R.",
    text: "Compré mi MetaQuest acá. Mejor precio y atención del mercado.",
    rating: 5
  }
];

// Servicios de Páginas Web
export const webServicesData = [
  {
    id: 1,
    name: "Hosting Web",
    category: "Infraestructura",
    description: "Tu sitio siempre online. Ofrecemos hosting confiable y seguro con soporte técnico incluido. Servidores de alta velocidad, certificados SSL gratuitos y backups automáticos para que tu página esté protegida 24/7.",
    features: [
      "Servidores de alta velocidad",
      "Certificado SSL gratuito",
      "Backups automáticos diarios",
      "Soporte técnico incluido",
      "99.9% uptime garantizado",
      "Panel de control intuitivo"
    ],
    priceText: "Desde $18.000/mes",
    featured: true,
    images: [
      "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800",
      "https://images.unsplash.com/photo-1639066648921-82d4500abf1a?w=800",
      "https://images.unsplash.com/photo-1695668548342-c0c1ad479aee?w=800",
      "https://images.unsplash.com/photo-1544197150-b99a580bb7a8?w=800"
    ]
  },
  {
    id: 2,
    name: "Desarrollo Web",
    category: "Desarrollo",
    description: "Creamos tu página web profesional a medida. Diseño moderno, responsive y optimizado para todos los dispositivos. Desde landing pages hasta sitios corporativos completos. Tu presencia digital empieza acá.",
    features: [
      "Diseño personalizado",
      "100% responsive (móvil, tablet, PC)",
      "Optimizado para velocidad",
      "Integración con redes sociales",
      "Formularios de contacto",
      "Capacitación incluida"
    ],
    priceText: "Consultar",
    featured: true,
    images: [
      "https://images.unsplash.com/photo-1461749280684-dccba630e2f6?w=800",
      "https://images.unsplash.com/photo-1542831371-29b0f74f9713?w=800",
      "https://images.unsplash.com/photo-1515879218367-8466d910aaa4?w=800",
      "https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=800"
    ]
  },
  {
    id: 3,
    name: "Posicionamiento en Google (SEO)",
    category: "Marketing",
    description: "Que te encuentren cuando te buscan. Optimizamos tu sitio para aparecer en los primeros resultados de Google. Más visibilidad = más clientes. Análisis de palabras clave, optimización de contenido y seguimiento de resultados.",
    features: [
      "Análisis de palabras clave",
      "Optimización On-Page",
      "Alta en Google My Business",
      "Reportes mensuales",
      "Mejora de velocidad de carga",
      "Estrategia de contenidos"
    ],
    priceText: "Consultar",
    featured: true,
    images: [
      "https://images.pexels.com/photos/270637/pexels-photo-270637.jpeg?w=800",
      "https://images.pexels.com/photos/577195/pexels-photo-577195.jpeg?w=800",
      "https://images.pexels.com/photos/669612/pexels-photo-669612.jpeg?w=800",
      "https://images.pexels.com/photos/185576/pexels-photo-185576.jpeg?w=800"
    ]
  },
  {
    id: 4,
    name: "Catálogo y Tienda Online",
    category: "E-commerce",
    description: "Vendé las 24hs del día, los 7 días de la semana. Un catálogo online profesional que articula directamente con la compra. Mostrá tus productos, recibí pedidos y gestioná tu inventario. Tu negocio nunca cierra.",
    features: [
      "Catálogo de productos ilimitado",
      "Carrito de compras integrado",
      "Múltiples medios de pago",
      "Gestión de stock",
      "Notificaciones de pedidos",
      "Panel de administración fácil"
    ],
    priceText: "Consultar",
    featured: false,
    images: [
      "https://images.pexels.com/photos/230544/pexels-photo-230544.jpeg?w=800",
      "https://images.pexels.com/photos/50987/money-card-business-credit-card-50987.jpeg?w=800",
      "https://images.pexels.com/photos/5632397/pexels-photo-5632397.jpeg?w=800",
      "https://images.pexels.com/photos/39284/macbook-apple-imac-computer-39284.jpeg?w=800"
    ]
  }
];

// Servicios de Estudio de Grabación
export const recordingStudioServices = [
  {
    id: 1,
    name: "Grabación de Bandas",
    category: "Grabación",
    description: "¡Hacé realidad tu proyecto musical! Contamos con todas las herramientas profesionales para llevar adelante tu grabación de manera fácil y accesible. Sala acústicamente tratada, micrófonos de alta gama, consola profesional y técnico de sonido incluido.",
    features: [
      "Sala acústicamente tratada",
      "Micrófonos profesionales",
      "Consola de mezcla de última generación",
      "Técnico de sonido incluido",
      "Grabación multipista",
      "Edición y mezcla básica incluida"
    ],
    priceText: "Consultar",
    featured: true,
    images: [
      "https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?w=800",
      "https://images.unsplash.com/photo-1574517947730-55cb23e608c2?w=800",
      "https://images.unsplash.com/photo-1531651008558-ed1740375b39?w=800",
      "https://images.unsplash.com/photo-1598653222000-6b7b7a552625?w=800"
    ]
  },
  {
    id: 2,
    name: "Clases de Música",
    category: "Educación",
    description: "Aprendé música con profesionales. Ofrecemos talleres de guitarra, canto, batería, piano, bajo y lectoescritura musical. También cursos de producción musical, uso de herramientas digitales con conceptos de IA, masterización, mezcla y producción profesional.",
    features: [
      "Talleres: Guitarra, Canto, Batería, Piano, Bajo",
      "Lectoescritura musical",
      "Cursos de producción musical",
      "Herramientas digitales e IA",
      "Master, mezcla y producción",
      "Certificación al finalizar"
    ],
    priceText: "Consultar",
    featured: true,
    images: [
      "https://images.unsplash.com/photo-1696522732406-065ef560da8c?w=800",
      "https://images.unsplash.com/photo-1519076976365-9c64dbd98317?w=800",
      "https://images.unsplash.com/photo-1471478331149-c72f17e33c73?w=800",
      "https://images.unsplash.com/photo-1475275166152-f1e8005f9854?w=800"
    ]
  },
  {
    id: 3,
    name: "Streaming",
    category: "Streaming",
    description: "Espacio amplio y profesional para tus programas en vivo. Contamos con fondo verde (chroma key), múltiples TVs para escenografía dinámica y operación técnica completa incluida. Ideal para podcasts, entrevistas, programas y transmisiones en vivo.",
    features: [
      "Amplio espacio para programas",
      "Fondo verde (Chroma Key)",
      "TVs para escenografía",
      "Operación técnica incluida",
      "Iluminación profesional",
      "Conexión de alta velocidad"
    ],
    priceText: "Consultar",
    featured: true,
    images: [
      "https://images.unsplash.com/photo-1644535662386-d83f6fb96a43?w=800",
      "https://images.unsplash.com/photo-1643652631396-181154ca7d8a?w=800",
      "https://images.unsplash.com/photo-1668606144327-837f2d8eac94?w=800",
      "https://images.unsplash.com/photo-1478737270239-2f02b77fc618?w=800"
    ]
  },
  {
    id: 4,
    name: "Sala de Ensayo",
    category: "Ensayo",
    description: "Reservá tu sala y ensayá con tu banda. Operación técnica profesional incluida para que solo te preocupes por tocar. Disfrutá de nuestro servicio de bar mientras ensayás. Equipamiento completo: batería, amplificadores, PA y microfonía.",
    features: [
      "Operación técnica incluida",
      "Servicio de bar",
      "Batería profesional",
      "Amplificadores de guitarra y bajo",
      "Sistema de PA completo",
      "Microfonía incluida"
    ],
    priceText: "Consultar",
    featured: false,
    hasReservation: true,
    images: [
      "https://images.unsplash.com/photo-1509566393488-f7eb8dfc1a1f?w=800",
      "https://images.unsplash.com/photo-1622316671539-7509233e4cc5?w=800",
      "https://images.unsplash.com/photo-1519892300165-cb5542fb47c7?w=800",
      "https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?w=800"
    ]
  }
];

// Productos de Impresión 3D
export const printing3DProducts = [
  {
    id: 1,
    name: "Servicio de Impresión 3D",
    price: null,
    category: "Servicios",
    description: "Imprimimos tus diseños en 3D con alta precisión. Cotizá tu proyecto personalizado.",
    image: "https://images.unsplash.com/photo-1705475025559-ad8efdedc74f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHwzRCUyMHByaW50ZXJ8ZW58MHx8fHwxNzY3MTI5MTg3fDA&ixlib=rb-4.1.0&q=85",
    featured: true,
    priceText: "Consultar"
  },
  {
    id: 2,
    name: "Figuras y Modelos Personalizados",
    price: null,
    category: "Productos",
    description: "Figuras de acción, maquetas, prototipos y modelos decorativos impresos a medida.",
    image: "https://images.unsplash.com/photo-1760446410459-65325b72ef59?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHwzRCUyMHByaW50ZWQlMjBvYmplY3RzfGVufDB8fHx8MTc2NzEyOTE5M3ww&ixlib=rb-4.1.0&q=85",
    featured: true,
    priceText: "Consultar"
  },
  {
    id: 3,
    name: "Piezas y Repuestos",
    price: null,
    category: "Productos",
    description: "Fabricamos piezas de repuesto, engranajes, soportes y componentes funcionales.",
    image: "https://images.unsplash.com/photo-1707735325033-af8b8ad6a01f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHw0fHwzRCUyMHByaW50ZWQlMjBvYmplY3RzfGVufDB8fHx8MTc2NzEyOTE5M3ww&ixlib=rb-4.1.0&q=85",
    featured: false,
    priceText: "Consultar"
  },
  {
    id: 4,
    name: "Filamentos PLA Premium",
    price: 15000,
    category: "Insumos",
    description: "Filamento PLA de alta calidad, varios colores disponibles. Rollo de 1kg.",
    image: "https://images.unsplash.com/photo-1739169169463-450148af26ce?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxmaWxhbWVudCUyMHNwb29sfGVufDB8fHx8MTc2NzEyOTIwNnww&ixlib=rb-4.1.0&q=85",
    featured: false,
    priceText: null
  },
  {
    id: 5,
    name: "Diseño 3D a Medida",
    price: null,
    category: "Servicios",
    description: "Te ayudamos a diseñar tu modelo 3D desde cero. Ideal para proyectos únicos.",
    image: "https://images.unsplash.com/photo-1642969164999-979483e21601?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHwzRCUyMHByaW50ZXJ8ZW58MHx8fHwxNzY3MTI5MTg3fDA&ixlib=rb-4.1.0&q=85",
    featured: true,
    priceText: "Consultar"
  },
  {
    id: 6,
    name: "Accesorios y Organizadores",
    price: null,
    category: "Productos",
    description: "Organizadores de escritorio, soportes para celular, accesorios útiles del día a día.",
    image: "https://images.unsplash.com/photo-1760446410471-5621d874a4a9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHwzRCUyMHByaW50ZWQlMjBvYmplY3RzfGVufDB8fHx8MTc2NzEyOTE5M3ww&ixlib=rb-4.1.0&q=85",
    featured: false,
    priceText: "Consultar"
  }
];
